import type { ChatMessage, ChatTranscriptItem } from "~/ai-chat/model/chat-message";

const ROLE_LABEL: Record<ChatMessage["role"], string> = {
  user: "You",
  assistant: "Istari",
  system: "System",
};

/**
 * Render a chat transcript as Markdown for "save chat as a resource". Only
 * message turns are included — transient error bubbles are dropped.
 */
export function chatTranscriptToMarkdown(title: string, items: ChatTranscriptItem[]): string {
  const heading = `# ${title.trim() || "Istari chat"}`;
  const turns = items
    .filter((item): item is ChatMessage => item.kind === "message")
    // trimEnd (not trim): preserve leading whitespace/newlines so indented code blocks and other
    // structure a turn opens with survive the round-trip to Markdown.
    .map((message) => `**${ROLE_LABEL[message.role]}:** ${message.content.trimEnd()}`);
  return `${[heading, ...turns].join("\n\n")}\n`;
}

/** Safe `.md` filename derived from the chat title. */
export function chatResourceFilename(title: string): string {
  const slug = title
    .trim()
    .replace(/[^\w.-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
  return `${slug || "istari-chat"}.md`;
}
